export default __webpack_public_path__ + "static/media/room-mel-2.cab87552.jpg";